import { FlatTreeControl } from "@angular/cdk/tree"
import { Component, inject } from "@angular/core"
import { MatDialog } from "@angular/material/dialog"
import { MatTreeFlatDataSource, MatTreeFlattener } from "@angular/material/tree"
import { ActivatedRoute } from "@angular/router"

import { routes } from "../../consts"
import { AuthService } from "../services/auth.service"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const TREE_DATA: any = [
  {
    name: "Quiz",
    expanded: false,
    children: [
      {
        name: "Active",
        route: routes.QUIZ,
        active: "active"
      },
      {
        name: "All",
        route: routes.QUIZ_EVENTS_ALL,
        active: "active"
      }
      // {
      //   name: "Test Payout",
      //   route: routes.QUIZ_TEST_PAYOUT,
      //   active: "active"
      // }
    ],
    icon: "quiz"
  },
  {
    name: "Leaderboard",
    expanded: false,
    children: [
      {
        name: "Active",
        route: routes.LEADERBOARD,
        active: "active"
      },
      {
        name: "All",
        route: routes.LEADERBOARDS_ALL,
        active: "active"
      }
    ],
    icon: "leaderboard"
  },
  {
    name: "Auction v2",
    expanded: false,
    children: [
      {
        name: "Active",
        route: routes.AUCTIONV2,
        active: "active"
      },
      {
        name: "All",
        route: routes.AUCTIONSV2_ALL,
        active: "active"
      }
    ],
    icon: "gavel"
  },
  {
    name: "Auction",
    expanded: false,
    children: [
      {
        name: "Active",
        route: routes.AUCTION,
        active: "active"
      },
      {
        name: "All",
        route: routes.AUCTIONS_ALL,
        active: "active"
      }
    ],
    icon: "gavel"
  },
  {
    name: "Notifications",
    expanded: false,
    children: [
      {
        name: "Send",
        route: routes.NOTIFICATIONS,
        active: "active"
      },
      {
        name: "List",
        route: routes.NOTIFICATIONS_LIST,
        active: "active"
      }
    ],
    icon: "message"
  },
  {
    name: "Config",
    expanded: false,
    route: routes.CONFIG,
    icon: "settings"
  }
]

/** Flat node with expandable and level information */
interface RouteNode {
  expandable: boolean
  name: string
  level: number
  children?: RouteNode[]
}

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
  standalone: false
})
export class SidebarComponent {
  public routes: typeof routes = routes
  public isOpenUiElements = false
  authService = inject(AuthService)
  lockedBrandSubject = this.authService.brandLockedSubject

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private _transformer = (node: any, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      level,
      ...node
    }
  }

  treeFlattener = new MatTreeFlattener<RouteNode, RouteNode>(
    this._transformer,
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.children
  )

  treeControl = new FlatTreeControl<RouteNode>(
    (node) => node.level,
    (node) => node.expandable
  )

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener)

  constructor(
    public dialog: MatDialog,
    public route: ActivatedRoute
  ) {
    this.lockedBrandSubject.subscribe((brand) => {
      this.dataSource.data = TREE_DATA.filter((node: { name: string }) => {
        return !brand || node.name === "Leaderboard" || node.name === "Quiz"
      })
    })
  }

  hasChild = (_: number, node: RouteNode) => node.expandable
}
